// extracted by mini-css-extract-plugin
module.exports = {"amount":"AmountPerMonth_amount__2Sn2V","amount__label":"AmountPerMonth_amount__label__3Dbjz","amount__value":"AmountPerMonth_amount__value__CjXE_"};